<template>
    <PDFViewer
      v-bind="{url}"
      @document-errored="onDocumentErrored">
      <PDFUploader
        v-if="enableUploader"
        :documentError="documentError"
        @updated="showPDF"
        slot="header"
        class="header-item"
        />
    </PDFViewer>
</template>

<script>

import { mapState } from 'vuex'
import QReport from '@/api/QReportsItem'
import PDFUploader from '../components/pdf_viewer/components/PDFUploader.vue'
import PDFViewer from '../components/pdf_viewer/components/PDFViewer.vue'

export default {
  name: 'app',

  components: {
    PDFUploader,
    PDFViewer,
  },

  mounted: function(){
    this.showPDF()
  },
  computed: mapState([
    'sitePath',
  ]),

  data() {
    return {
      url: '',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
    };
  },

  methods: {
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    showPDF(){
      QReport.pdfQUnit(
          this.sitePath,
          this.$route.query.uid,
          this.$route.query.template
      ).then(data => {      
        console.log(data.data)
        var newBlob = new Blob([data.data], {type: 'application/pdf'})
        console.log(newBlob)
        const ob = window.URL.createObjectURL(newBlob)

        this.documentError = undefined;
        this.url = ob
      }).catch(error => 
        console.log(error)
      )
    }
  },

}
</script>


<style lang="scss">
  @import "@/sass/pdfviewer.scss";
</style>
